import { ReactElement, useContext } from "react";
import styles from "./PersonalInfo.module.css";
import GeneralInformationDefault from "./components/GeneralInformation/GeneralInformationDefault";
import ContactInformation from "./components/ContactInformation/ContactInformation";
import AddressInformation from "./components/AddressInformation/AddressInformation";
import { useProfileContextData } from "pages/employer-of-record/employee-profile/contexts/ProfileInfoContext";
import ProfileInfoCard from "./ProfileInfoCard";
import BadgeTitle from "./components/BadgeTitle";
import { SupportedCountriesContext } from "pages/employer-of-record/contexts/supportedCountriesContext";
import { useFields } from "pages/employer-of-record/configs";
import {
  NeonSkyContext,
  NeonSkyFeatureFlag,
} from "lib/neon-sky/neon-sky-provider";
import { buildASOPath } from "lib/resource-finder";
import { useIsDisable1jActive } from "app/preserve-disable-1j";

type Props = {
  editable: boolean;
  isOwnProfile: boolean;
};

export default function PersonalInfo({
  editable,
  isOwnProfile = false,
}: Props): ReactElement {
  const { featureFlags } = useContext(NeonSkyContext);
  const { getCountryName } = useContext(SupportedCountriesContext);
  const { profileInfo, memberCanonicalId } = useProfileContextData();
  const isDisable1jActive = useIsDisable1jActive();

  if (
    featureFlags[NeonSkyFeatureFlag.PERMIT_EOR_IN_PERSONAL_INFORMATION] &&
    featureFlags[NeonSkyFeatureFlag.PERMIT_ADMIN_PERSONAL_INFORMATION] &&
    memberCanonicalId &&
    !isOwnProfile &&
    !isDisable1jActive
  ) {
    window.location.href = buildASOPath(
      `/member/${memberCanonicalId}/personal-info`
    );
  }

  const cartaoFields = useFields({
    scenario: "viewProfile",
    informationType: "cartao",
  });

  const rgFields = useFields({
    scenario: "viewProfile",
    informationType: "rg",
  });

  const benefitsFields = useFields({
    scenario: "viewProfile",
    informationType: "benefits",
  });

  const infonavitFonacotFields = useFields({
    scenario: "viewProfile",
    informationType: "infonavitFonacot",
  });

  const workCountry = profileInfo?.eorEmployeeProfile?.employment?.workCountry;
  const countryName = getCountryName(workCountry);

  return (
    <>
      <div className={styles.cardSection}>
        <GeneralInformationDefault editable={editable} />
        <AddressInformation editable={editable} />
        <ContactInformation editable={editable} />

        {!!cartaoFields.length && (
          <ProfileInfoCard
            title={
              (
                <BadgeTitle title="Cartão de Cidadão" badgeText={countryName} />
              ) as unknown as string
            }
            editable
            informationType="pension"
            fields={cartaoFields}
          />
        )}

        {!!rgFields.length && (
          <ProfileInfoCard
            title={
              (
                <BadgeTitle
                  title="Carteira de identidade Nacional"
                  badgeText={countryName}
                />
              ) as unknown as string
            }
            editable
            informationType="rg"
            fields={rgFields}
          />
        )}

        {!!benefitsFields.length && (
          <ProfileInfoCard
            title={
              (
                <BadgeTitle title="Benefits" badgeText={countryName} />
              ) as unknown as string
            }
            editable={false}
            informationType="benefits"
            fields={benefitsFields}
          />
        )}

        {!!infonavitFonacotFields.length && (
          <ProfileInfoCard
            title={
              (
                <BadgeTitle
                  title="Infonavit & Fonacot Loans"
                  badgeText={countryName}
                />
              ) as unknown as string
            }
            editable
            informationType="infonavitFonacot"
            fields={infonavitFonacotFields}
          />
        )}
      </div>
    </>
  );
}
